import styled from 'styled-components';

export const StyledDragAndMatchGameLoop = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background: white;

  .sprite-img-droppable {
    user-select: none;
    pointer-events: none;
    -webkit-user-drag: none;
  }

  &.game-finished {
    .sprite-img-droppable {
      cursor: pointer;
      pointer-events: auto;
    }
    .draggable-text {
      &.correct {
        cursor: pointer;
      }
      &.wrong {
        cursor: pointer;
      }
    }
  }

  .user-interaction-none {
    pointer-events: none;
    user-select: none;
    -webkit-user-drag: none;
  }
`;
